import { apiSlice } from "../../app/api/apiSlice";

export const eDojangApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEDojangGlobalAccess: builder.query({
      query: () => "/e-dojang/global-access",
      providesTags: ["EDojang"],
    }),
    updateEDojangGlobalAccess: builder.mutation({
      query: ({ enabled }) => ({
        url: "/e-dojang/global-access",
        method: "PATCH",
        body: { enabled },
      }),
      invalidatesTags: ["EDojang", "Tenant"],
    }),
    getEDojangOverview: builder.query({
      query: () => "/e-dojang/overview",
      providesTags: ["EDojang"],
    }),
    getEDojangAdminDomains: builder.query({
      query: () => "/e-dojang/admin/domains",
      providesTags: ["EDojang"],
    }),
    createEDojangDomainItem: builder.mutation({
      query: ({ domainKey, ...body }) => ({
        url: `/e-dojang/admin/domains/${domainKey}/items`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["EDojang"],
    }),
    updateEDojangDomainItem: builder.mutation({
      query: ({ domainKey, itemId, ...body }) => ({
        url: `/e-dojang/admin/domains/${domainKey}/items/${itemId}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["EDojang"],
    }),
    deleteEDojangDomainItem: builder.mutation({
      query: ({ domainKey, itemId }) => ({
        url: `/e-dojang/admin/domains/${domainKey}/items/${itemId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EDojang"],
    }),
  }),
});

export const {
  useGetEDojangGlobalAccessQuery,
  useUpdateEDojangGlobalAccessMutation,
  useGetEDojangOverviewQuery,
  useGetEDojangAdminDomainsQuery,
  useCreateEDojangDomainItemMutation,
  useUpdateEDojangDomainItemMutation,
  useDeleteEDojangDomainItemMutation,
} = eDojangApiSlice;
